const ID = Object.freeze({
  ACCOUNT_DETAIL_CAPITALIZATION: 'chart-account-detail-capitalization',
  ACCOUNT_DETAIL_PERFORMANCE: 'chart-account-detail-performance',
  BLOCKS_LIST: 'chart-blocks-list',
  DASHBOARD_PRICE: 'chart-dashboard-price',
  DASHBOARD_TOKEN: 'chart-dashboard-token',
  EXCHANGE_RATE_TOKEN: 'chart-exchange-rate-token',
  PROPOSAL_DETAIL: 'chart-proposal-detail',
  PROPOSALS_LIST: 'chart-proposals-list',
  TRANSACTIONS_LIST: 'chart-transactions-list',
  VALIDATOR_DETAIL: 'chart-validator-detail',
  VALIDATORS_LIST: 'chart-validators-list',
});

const TYPE = Object.freeze({
  BAR: 'bar',
  LINE: 'line',
  PIE: 'pie',
});

export default Object.freeze({
  ID,
  TYPE,
});
